<template>
  <v-modal name="remove-payment-method-modal" :loading="loading">
    <h2 slot="header">{{ $t('companySettings.billing.paymentMethods.removePaymentMethod') }}</h2>
    <div slot="content">
      <v-form :onSubmit="deleteMethod">
        <div slot="row">
          <p>{{ $t('companySettings.billing.paymentMethods.removePaymentMethodMessage') }}</p>
        </div>
        <div slot="formButtons">
          <v-button
              type="error"
              class="float-right"
              subtype="submit"
              href="#"
              data-ec="billing_remove_payment_method_modal"
              data-et="delete_button">
            <icon name="trash"></icon>
            <span>{{ $t('functional.delete') }}</span>
          </v-button>
        </div>
      </v-form>
    </div>
  </v-modal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';

export default {
  name: 'RemovePaymentMethodModal',
  inject: {
    $validator: '$validator',
  },
  components: {
    VButton,
    VForm,
    VModal,
  },
  props: {
    method: {
      type: [String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    deleteMethod() {
      this.loading = true;

      this.$store.dispatch('paymentMethods/DELETE_METHOD', { id: this.method.toString() }).then(() => {
        this.$bus.$emit('closeModal');
      }).finally(() => {
        this.loading = false;
      });
    },
    modalBack() {
      this.$bus.$emit('closeModal');
    },
  },
};
</script>
